import SearchPanel from '../CommonComponents/SearchPanel';
import { useState, useEffect } from 'react';
import DashboardTableWrapper from './DashboardTableWrapper';

function DashboardTableMain({ DashboardTableData }) {

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (DashboardTableData.length > 0) {
      const dataKeys = Object.keys(DashboardTableData[0]);
      const formattedColumns = dataKeys.map((key) =>
        key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (str) => str.toUpperCase())
          .trim()
      );
      // Set columns for the dashboard table
      setColumns(formattedColumns.filter((_, index) => index >= 1 && index <= 18));
    }
  }, [DashboardTableData]);

  const columnTypeMapping = {
    Sno: 'number',
    Client: 'string',
    Division: 'string',
    Scope: 'string',
    // Add other mappings as needed
  };

  return (
    <>
      <div className="m-2">
        <div className="flex gap-3 relative sm:h-[calc(100vh_-_190px)] max-h-370px sm:flex-row">
          <SearchPanel columns={columns} columnTypeMapping={columnTypeMapping} />
          <div className="panel p-0 mb-4 flex-1 overflow-auto">
            <div className="flex flex-col h-full">
              {/* this makes it vertically arranged */}
              <div className="p-4 flex sm:flex-row flex-col w-full sm:items-center gap-4">
                <div className="relative group flex-1">
                  <div className="flex items-center justify-between mb-5">
                    <h5 className="font-semibold text-lg dark:text-white-light">Overall Data</h5>
                  </div>
                  <div className="relative">
                    <DashboardTableWrapper Dashboarddata={DashboardTableData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default DashboardTableMain;
